module.exports = __webpack_public_path__ + "static/media/seek_15_next.55f4e2b2.svg";